import { render, staticRenderFns } from "./Endpoints.vue?vue&type=template&id=9de4fa1e&"
import script from "./Endpoints.vue?vue&type=script&lang=js&"
export * from "./Endpoints.vue?vue&type=script&lang=js&"
import style0 from "./Endpoints.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports